export type RateLimitBucket = 'instant_connect' | 'form_submit' | 'contact_request';

type BucketConfig = {
  windowMs: number;
  max: number;
};

const DEFAULTS: Record<RateLimitBucket, BucketConfig> = {
  instant_connect: { windowMs: 60_000, max: 5 },
  form_submit: { windowMs: 60_000, max: 5 },
  contact_request: { windowMs: 60_000, max: 10 }
};

type StoredState = {
  ts: number[];
};

const storageKey = (bucket: RateLimitBucket) => `rl_${bucket}_v1`;

export function isRateLimited(bucket: RateLimitBucket, config: Partial<BucketConfig> = {}): boolean {
  const { windowMs, max } = { ...DEFAULTS[bucket], ...config };
  const now = Date.now();
  let state: StoredState = { ts: [] };
  try {
    const raw = localStorage.getItem(storageKey(bucket));
    if (raw) state = JSON.parse(raw);
  } catch {}
  state.ts = state.ts.filter(t => now - t < windowMs);
  const limited = state.ts.length >= max;
  try {
    localStorage.setItem(storageKey(bucket), JSON.stringify(state));
  } catch {}
  return limited;
}

export function consumeToken(bucket: RateLimitBucket, config: Partial<BucketConfig> = {}): { limited: boolean; remaining: number } {
  const { windowMs, max } = { ...DEFAULTS[bucket], ...config };
  const now = Date.now();
  let state: StoredState = { ts: [] };
  try {
    const raw = localStorage.getItem(storageKey(bucket));
    if (raw) state = JSON.parse(raw);
  } catch {}
  state.ts = state.ts.filter(t => now - t < windowMs);
  if (state.ts.length < max) {
    state.ts.push(now);
  }
  const remaining = Math.max(0, max - state.ts.length);
  try {
    localStorage.setItem(storageKey(bucket), JSON.stringify(state));
  } catch {}
  return { limited: state.ts.length > max, remaining };
}




